<match-details 
  *ngIf="matchId"
  [isVacancy]="role === USER_ROLES.talent"
  [matchId]="matchId" 
  [leastFoundSkills]="leastFoundSkills"
  [vacancySkillNames]="vacancySkillNames"
  (onClose)="matchId = null"
  (onAnalyticsEvent)="onMatchDetailsAnalyticsEvent($event)"
  [sourcingType]="sourcingType">
</match-details>

<div class="match-item__whatsapp-backdrop" *ngIf="showWhatsappPopup" (click)="closeWhatsappPopup($event)"></div>
<div class="match-item__whatsapp-modal" *ngIf="showWhatsappPopup" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
  <div class="match-item__whatsapp-modal__header">
    <div class="match-item__whatsapp-modal__title">
      <i class="app-ico app-ico__social-whatsapp"></i>
      {{ 'WhatsApp.OpenTitle' | translate }}
    </div>
    <button type="button" class="match-item__whatsapp-modal__close" (click)="closeWhatsappPopup($event)" [attr.aria-label]="'Common.Close' | translate">
      <i class="app-ico-mask app-ico-mask__x"></i>
    </button>
  </div>
  <textarea
    class="match-item__whatsapp-modal__message"
    [(ngModel)]="whatsappMessage"
    [disabled]="revealingPhone"
    [attr.aria-label]="'WhatsApp.MessageLabel' | translate">
  </textarea>
  <div class="match-item__whatsapp-modal__actions">
    <button type="button" class="is-btn is-btn__outfill" (click)="closeWhatsappPopup($event)">{{ 'Common.Cancel' | translate }}</button>
    <button type="button" class="is-btn" [disabled]="revealingPhone" [attr.aria-busy]="revealingPhone" (click)="openWhatsapp($event)">
      <span role="status" aria-live="polite">{{ revealingPhone ? 'Please wait ...' : ('WhatsApp.OpenAction' | translate) }}</span>
    </button>
  </div>
  <p *ngIf="contactError" role="alert">{{ contactError }}</p>
</div>

<div class="match-item" *ngIf="item" 
  [resizeListener]="{ width: 400, class: 'is-narrow' }"
  [class.a-section]="standAlone"
  [class.in-list]="!standAlone"
  [class.is-active]="isActive"
  [class.is-archived]="item.isArchived"
  [class.has-extra-info]="showExtraInfo && role === USER_ROLES.hm"
  (click)="onClick.emit()">
  <div class="match-item__header">
    <div class="match-item__avatar"  
      *ngIf="role === USER_ROLES.talent"
      [avatarImage]="item.company?.logo ? item.company?.logo : item.hm?.avatar ? item.hm?.avatar : null"
      [avatarTitle]="item.company?.name ? item.company?.name : item.hm?.name ? item.hm?.name : null">
    </div>
    <div class="match-item__avatar"
      *ngIf="role === USER_ROLES.hm"
      [avatarImage]="item.talent?.avatar"
      [avatarTitle]="item.talent?.name">
    </div>
    <div class="private-sourcing-marker"
         style="display:none"
         [attr.data-internal-sourcing]="role === USER_ROLES.hm && (!sourcingType || sourcingType === 1) ? ('InternalSourcing') : null"
         [attr.data-external-sourcing]="role === USER_ROLES.hm && (!sourcingType || sourcingType === 2) ? ('ExternalSourcing') : null">
    </div>
    <div class="match-item__title">
      <ng-container *ngIf="role === USER_ROLES.talent">
        <h4 *ngIf="item.company?.name ? item.company?.name : item.hm?.name ? item.hm?.name : null" >
          {{ item.company?.name ? item.company?.name : item.hm?.name ? item.hm?.name : ('MatchItem.NotDefined' | translate) }}
        </h4>
        <span wordWrap>{{ item.vacancy.jobName ? item.vacancy.jobName : item.vacancy.jobPosition }}</span>
      </ng-container>
      <ng-container *ngIf="role === USER_ROLES.hm">
        <h4 *ngIf="item.talent?.name" class="match-item__name-row">
          {{ item.talent.name }}
          <span class="candidate-status-badge status-{{getStatusClass(sourcingType)}}" *ngIf="statusFilter === null && isLocationIndia && sourcingType !== undefined && isKnownSourcingType(sourcingType)">
             <span class="status-dot-wrapper">
               <span class="status-dot" [class.is-live]="sourcingType === SourcingType.Passive"></span>
               <span class="status-pulse-ring" *ngIf="sourcingType === SourcingType.Passive"></span>
               <span class="status-pulse-ring status-pulse-ring--delayed" *ngIf="sourcingType === SourcingType.Passive"></span>
             </span>
             {{ getStatusLabel(sourcingType) | translate }}
          </span>
        </h4>
        <div class="match-item__job-position">
          <badges-count [validJobTitles]="validJobTitles"></badges-count>
          {{ item.talent?.jobTitle }} 
         <ng-container *ngIf="showExtraInfo">
          <!-- {{ item.talent?.workPlace }} -->
          <ng-container *ngIf="item.talent?.location?.country"><span *ngIf="item.talent?.workPlace &&item.talent?.location?.country">, </span>{{ item.talent.location.country }}</ng-container>
        </ng-container>
        </div>
      </ng-container>
    </div>
    <div class="match-item__verification-status" *ngIf="showExtraInfo && (uanVerification || isVerificationInProgress || shouldShowVerifyUan || verificationMessage)">
      <span
        *ngIf="uanVerification && !isVerificationCheckFailed"
        class="match-item__uan-badge match-item__uan-badge--{{ getUanStatusClass(uanVerification.status) }}"
        (click)="$event.stopPropagation()">
        <svg class="match-item__uan-shield" viewBox="0 0 16 18" aria-hidden="true">
          <path class="match-item__uan-shield-outline" d="M8 1.7L13.2 3.55V8.15C13.2 11.35 11.15 14.35 8 16.1C4.85 14.35 2.8 11.35 2.8 8.15V3.55L8 1.7Z"></path>
          <path class="match-item__uan-shield-divider" d="M8 2.65V15.15"></path>
        </svg>
        {{ getUanStatusKey(uanVerification.status) | translate }}
        <span class="match-item__uan-info" *ngIf="uniqueUanReasons.length" tabindex="0">i</span>
        <span class="match-item__uan-tooltip" *ngIf="uniqueUanReasons.length" role="tooltip">
          <span *ngFor="let reason of uniqueUanReasons">{{ getUanReasonLabel(reason) }}</span>
        </span>
      </span>
      <span *ngIf="isVerificationInProgress" class="match-item__verification-progress" aria-live="polite">
        <span class="match-item__verification-loader" aria-hidden="true"></span>
        {{ 'EmploymentVerification.InProgress' | translate }}
      </span>
      <span
        *ngIf="shouldShowVerifyUan"
        [attr.title]="!isUanNumberValid
          ? ('EmploymentVerification.InvalidNumber' | translate)
          : (!uanVerificationEnabled
            ? ('EmploymentVerification.ServiceUnavailable' | translate)
            : (isVerificationCheckFailed ? getUanReasonLabel('VerificationCheckFailed') : null))"
      >
        <button
          type="button"
          class="match-item__verify-button"
          [class.match-item__verify-button--loading]="isActionLoading('verify')"
          [disabled]="!uanVerificationEnabled || !isUanNumberValid || isActionLoading('verify')"
          (click)="verifyUan($event)">
          <span *ngIf="isActionLoading('verify')" class="match-item__verification-loader" aria-hidden="true"></span>
          {{ (isActionLoading('verify')
            ? 'EmploymentVerification.InProgress'
            : (canRetryUan ? 'EmploymentVerification.RetryVerification' : 'EmploymentVerification.VerifyUan')) | translate }}
        </button>
      </span>
      <span *ngIf="verificationMessage" class="match-item__verification-message">{{ verificationMessage }}</span>
    </div>
    <div class="match-item__header-side">
      <i *ngIf="item.inComplete" class="app-ico-mask app-ico-mask__exclamation-red float-right"></i>
      <div *ngIf="!displayAsScore" class="custom-round-progress-wrapper" (click)="showMatch($event)">
        <div class="custom-round-progress"
             [ngClass]="scoreShadeClass"
             [attr.data-progress]="item.totalMatch"
             [style.--progress]="'360deg'">
          <span class="score-number {{ scoreShadeClass }}">{{ index }}</span>
        </div>
        <div class="custom-round-progress__label">
          {{ 'MatchItem.ShowDetails' | translate }}
        </div>
      </div>

      <div class="match-item__progress" *ngIf="item.totalMatch && isOtherMatch && displayAsScore">

        <div class="match-item__progress-inner">
          <round-progress
            class="tooltip"
            [small]="true"
            [score]="item.totalMatch"
            (click)="showMatch($event)">
          </round-progress>
          <div class="tooltiptext">{{ 'MatchItem.ShowDetails' | translate }}</div>

        </div>
      </div>

      <div class="match-item__progress" *ngIf="!isOtherMatch && item.talent?.onBoard?.isComplited">
        <i class="app-ico-mask app-ico-mask__check-circle"></i>
      </div>
    </div>
  </div>

  <div class="match-item__actions-icons" *ngIf="role === USER_ROLES.hm && vacancyId">
    <ng-container *ngIf="!item.isArchived">
      <div class="match-item__action-btn"
           [class.is-disabled]="isProcessingAction"
           *ngIf="hasResume"
           (click)="downloadResume($event)"
           [title]="'MatchItem.DownloadResume' | translate">
        <div class="match-item__action-loader" *ngIf="isActionLoading('download')"></div>
        <i *ngIf="!isActionLoading('download')" class="app-ico-mask app-ico-mask__download"></i>
      </div>
      <div class="match-item__action-btn"
           [class.is-disabled]="isProcessingAction"
           [class.is-liked]="item.isLiked"
           *ngIf="canManageOutreach"
           (click)="onThumbUp($event)"
           [title]="item.isLiked ? ('MatchItem.UnmarkCandidate' | translate) : ('MatchItem.MarkCandidate' | translate)">
        <div class="match-item__action-loader" *ngIf="isActionLoading('like')"></div>
        <i *ngIf="!isActionLoading('like')"
           class="app-ico-mask app-ico-mask__thumbs-up"
           [class.is-liked]="item.isLiked"></i>
      </div>
      <div class="match-item__action-btn"
           [class.is-disabled]="isProcessingAction"
           [class.is-danger]="true"
           *ngIf="canManageOutreach"
           (click)="onThumbDown($event)"
           [title]="'MatchItem.ArchiveCandidate' | translate">
        <div class="match-item__action-loader" *ngIf="isActionLoading('archive')"></div>
        <i *ngIf="!isActionLoading('archive')" class="app-ico-mask app-ico-mask__thumbs-down"></i>
      </div>
    </ng-container>
    <ng-container *ngIf="item.isArchived && sourcingType !== SourcingType.Passive">
      <div class="match-item__action-btn"
           [class.is-disabled]="isProcessingAction"
           *ngIf="canManageOutreach"
           (click)="onUnarchiveClick($event)"
           [title]="'MatchItem.UnarchiveCandidate' | translate">
        <div class="match-item__action-loader" *ngIf="isActionLoading('unarchive')"></div>
        <i *ngIf="!isActionLoading('unarchive')" class="app-ico-mask app-ico-mask__unarchive"></i>
      </div>
    </ng-container>
  </div>

  <div class="match-item__additional">
    <ng-container *ngIf="showExtraInfo && role === USER_ROLES.hm && item.talent">
      <div class="match-item__candidate-details">
        <div class="match-item__education" *ngIf="educationSummary as education">{{ education }}</div>

        <div *ngIf="item.talent.summary" class="match-item__summary">
          <div
            class="match-item__summary-text"
            [class.is-collapsed]="hasLongSummary && !isSummaryExpanded"
            [class.is-expanded]="isSummaryExpanded">
            {{ item.talent.summary }}
          </div>
          <button
            *ngIf="hasLongSummary"
            type="button"
            class="match-item__text-toggle"
            [attr.aria-expanded]="isSummaryExpanded"
            (click)="toggleSummary($event)">
            {{ (isSummaryExpanded ? 'MatchItem.ShowLess' : 'MatchItem.ShowMore') | translate }}
          </button>
        </div>

        <div *ngIf="item.talent.hardSkills?.length" class="match-item__skills">
          <span *ngFor="let skill of displaySkills | slice:0:visibleSkillsCount" [title]="skill" [class.is-matched]="isVacancySkill(skill)">{{ skill }}</span>
          <button
            *ngIf="item.talent.hardSkills.length > COLLAPSED_SKILLS_COUNT"
            type="button"
            class="match-item__skills-toggle"
            [attr.aria-expanded]="areSkillsExpanded"
            (click)="toggleSkills($event)">
            {{ areSkillsExpanded ? ('MatchItem.ShowLess' | translate) : '+' + (item.talent.hardSkills.length - COLLAPSED_SKILLS_COUNT) }}
          </button>
        </div>

        <div *ngIf="item.talent.socialMedia || hasValidWhatsappNumber" class="match-item__socials">
          <a *ngIf="item.talent.socialMedia?.linkedIn" [href]="item.talent.socialMedia.linkedIn | urlHttps" target="_blank" rel="noopener" (click)="onSocialClick($event, RecruiterActivityEventType.CandidateLinkedinClicked)">
            <i class="app-ico app-ico__social-linkedin"></i>
          </a>
          <a *ngIf="item.talent.socialMedia?.gitHub" [href]="item.talent.socialMedia.gitHub | urlHttps" target="_blank" rel="noopener" (click)="onSocialClick($event, RecruiterActivityEventType.CandidateGithubClicked)">
            <i class="app-ico app-ico__social-github"></i>
          </a>
          <a *ngIf="item.talent.socialMedia?.telegram" [href]="item.talent.socialMedia.telegram | urlHttps" target="_blank" rel="noopener" (click)="onSocialClick($event, RecruiterActivityEventType.CandidateTelegramClicked)">
            <i class="app-ico app-ico__social-telegram"></i>
          </a>
          <a *ngIf="item.talent.socialMedia?.twitter" [href]="item.talent.socialMedia.twitter | urlHttps" target="_blank" rel="noopener" (click)="onSocialClick($event, RecruiterActivityEventType.CandidateTwitterClicked)">
            <i class="app-ico app-ico__social-twitter"></i>
          </a>
          <a *ngIf="item.talent.socialMedia?.website" [href]="item.talent.socialMedia.website | urlHttps" target="_blank" rel="noopener" (click)="onSocialClick($event, RecruiterActivityEventType.CandidateWebsiteClicked)">
            <i class="app-ico app-ico__social-website"></i>
          </a>
          <a *ngIf="item.talent.socialMedia?.youtube" [href]="item.talent.socialMedia.youtube | urlHttps" target="_blank" rel="noopener" (click)="onSocialClick($event, RecruiterActivityEventType.CandidateYoutubeClicked)">
            <i class="app-ico app-ico__social-youtube"></i>
          </a>
          <a *ngIf="item.talent.socialMedia?.stackOverflow" [href]="item.talent.socialMedia.stackOverflow | urlHttps" target="_blank" rel="noopener" (click)="onSocialClick($event, RecruiterActivityEventType.CandidateStackoverflowClicked)">
            <i class="app-ico app-ico__social-stackoverflow"></i>
          </a>
          <a *ngIf="item.talent.socialMedia?.dribble" [href]="item.talent.socialMedia.dribble | urlHttps" target="_blank" rel="noopener" (click)="onSocialClick($event, RecruiterActivityEventType.CandidateDribbleClicked)">
            <i class="app-ico app-ico__social-dribble"></i>
          </a>
          <a *ngIf="item.talent.socialMedia?.facebook" [href]="item.talent.socialMedia.facebook | urlHttps" target="_blank" rel="noopener" (click)="$event.stopPropagation()">
            <i class="app-ico app-ico__social-facebook"></i>
          </a>
          <button
            type="button"
            *ngIf="hasValidWhatsappNumber"
            class="match-item__social-action"
            (click)="openWhatsappPopup($event)"
            [title]="'WhatsApp.OpenTitle' | translate"
            [attr.aria-label]="'WhatsApp.OpenTitle' | translate">
            <i class="app-ico app-ico__social-whatsapp"></i>
          </button>
        </div>

        <div class="match-item__meta-row" *ngIf="isLocationIndia && sourcingType !== SourcingType.Private && sourcingType !== SourcingType.External">
          <div class="match-item__compensation" *ngIf="candidateCompensationRows.length">
            <div
              class="match-item__compensation-item"
              *ngFor="let row of candidateCompensationRows"
              [class.is-missing]="row.isMissing"
              [title]="row.value">
              <span class="match-item__compensation-label" [title]="row.labelKey | translate">{{ row.shortLabelKey | translate }}</span>
              <span class="match-item__compensation-value">
                <span class="match-item__compensation-text">{{ row.value }}</span>
                <span *ngIf="row.isUnverified" class="match-item__salary-disclaimer" (click)="$event.stopPropagation()">
                  <button
                    type="button"
                    class="match-item__salary-info"
                    [attr.aria-label]="'Common.SalaryUnverified' | translate">
                    i
                  </button>
                  <span class="match-item__salary-tooltip" role="tooltip">{{ 'Common.SalaryUnverified' | translate }}</span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    

    <div *ngIf="role === USER_ROLES.hm && sourcingType === SourcingType.Private" class="private-sourcing-marker">
      <i class="app-ico app-ico__lock"></i>
      {{ 'MatchItem.PrivateSourcing' | translate }}
    </div>
    <div *ngIf="role === USER_ROLES.talent && item.vacancy.published">
      <i class="app-ico-mask app-ico-mask__calendar"></i> 
      {{ 'MatchItem.Published' | translate }} {{ item.vacancy.published | date: 'dd.MM.YY' }}
    </div>
    <div *ngIf="role === USER_ROLES.talent && item.vacancy?.salary && (item.vacancy.salary.amount || item.vacancy.salary.amountTo)">
      <i class="app-ico-mask app-ico-mask__salary"></i>
      {{ item.vacancy.salary.currency | currency }} 
      {{ item.vacancy.salary.amount | salaryDivider }} 
      <span class="is-dash" *ngIf="item.vacancy.salary.amount && item.vacancy.salary.amountTo"> - </span>
      {{ item.vacancy.salary.amountTo | salaryDivider }}
      {{ item.vacancy.salary.period | salaryPeriod }}
    </div>
    <div class="is-pointer"
      *ngIf="showActions && role === USER_ROLES.hm && item.vacancy && (item.vacancy.jobName || item.vacancy.jobPosition)"
      (click)="onGoToVacancy.emit({ 
        vacancyId: item.vacancy.id,
        jobPosition: item.vacancy.jobName ? item.vacancy.jobName : item.vacancy.jobPosition
      })">
      <i class="app-ico-mask app-ico-mask__rocket"></i>
      <span class="is-suits">
        {{ 'MatchItem.MatchingVacancy' | translate }} <b>{{ item.vacancy.jobName ? item.vacancy.jobName : item.vacancy.jobPosition }}</b>
      </span>
    </div>
    <!-- <div *ngIf="role === USER_ROLES.hm && item.talent?.salary && item.talent.salary.amount && !showActions">
      <i class="app-ico-mask app-ico-mask__salary"></i>
      {{ item.talent.salary.currency | currency }} {{ item.talent.salary.amount | salaryDivider }} {{ item.talent.salary.period | salaryPeriod }}
    </div> -->
    <div *ngIf="role === USER_ROLES.hm && !item?.talent?.onBoard?.currentRole" class="incomplete-profile">
      {{ 'MatchItem.LimitedInformation' | translate }}
    </div>

  </div>


  

  <!--  <div class="match-item__actions" *ngIf="showActions">
    <div class="is-btn is-btn__outfill" (click)="onExplore.emit(item)">{{ 'MatchItem.Explore' | translate }}</div>
    <div class="is-btn is-btn"
      *ngIf="role === USER_ROLES.talent"
      [class.was-applied]="item.vacancy.isApplied"
      (click)="item.vacancy.applyLink 
        ? goInternalVacancy(item.vacancy.applyLink)
        : onApply.emit({ matchId: item.id, vacancyId: item.vacancy.id })">
      <i *ngIf="!item.vacancy.applyLink && item.vacancy.isApplied" class="app-ico-mask app-ico-mask__checked"></i>
      <i *ngIf="item.vacancy.applyLink" class="app-ico app-ico__open-in-new"></i>
      {{ item.vacancy.isApplied ? ('MatchItem.Applied' | translate) : ('MatchItem.Apply' | translate) }}
    </div>
   <div class="is-btn is-btn"
      *ngIf="role === USER_ROLES.hm"
      (click)="onContact.emit({ 
        messageThreadId: item.messageThreadId,
        vacancyId: item.vacancy.id,
        talentId: item.talent.id 
      })">
      {{ 'MatchItem.Contact' | translate }}
    </div> 
  </div>-->
</div>
